import { render } from "./BiotronSafeInspector.vue?vue&type=template&id=498c1daa&scoped=true"
import script from "./BiotronSafeInspector.vue?vue&type=script&lang=js"
export * from "./BiotronSafeInspector.vue?vue&type=script&lang=js"

import "./BiotronSafeInspector.vue?vue&type=style&index=0&id=498c1daa&scoped=true&lang=css"

import exportComponent from "../../../../../biotron-pwa-ux-runtime/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498c1daa"]])

export default __exports__